<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs">
  <div class="ibox mainPartPage">
    <div class="ibox-content no-scroll-mode">
      <div class="row">
        <div class="col-sm-7">
          <filter [tabHeading]="'Announcements'" [buildings]="announcementService.buildingsForRead"></filter>
        </div>
        <div class="col-sm-2">
<!--          Announcements Filter-->
        </div>
        <div class="col-sm-3">
          <button *ngIf="rules.canCreate && rules.hasEnabledWebsites" type="button" class="btn btn-w-m btn-primary pull-right" routerLink="/announcements/new">
            <i class="fa fa-plus-circle"></i> New Announcement
          </button>
        </div>

      </div>
      <div class="row">
        <div class="col-sm-12">
          <filters-view></filters-view>
        </div>
      </div>
      <tabs-wrapper>
        <tab-item [tabId]="'allServiceRequests'" [ngClass]="{'sk-loading': announcementService.spinnerShow}">
          <announcements-list
                  [rules]="rules"
                  [announcements]="announcementService.data[announcementService.defaultTabId].data"
                  (onRemoveItem)="announcementService.removeNotice($event)"
          ></announcements-list>
          <spinner [spinnerShow]="announcementService.spinnerShow"></spinner>
        </tab-item>
        <pagination *ngIf="announcementService.data[announcementService.defaultTabId].total && urlService.queryParams['page']"
                    [total]="announcementService.data[announcementService.defaultTabId].total">
        </pagination>
      </tabs-wrapper>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements.component.html